function getCurrentLanguage() {
  return document.documentElement.lang;
}

function getShippingMetaObject() {
  let currentLanguage = getCurrentLanguage();
  let myHeaders = new Headers();
  myHeaders.append(
    "X-Shopify-Storefront-Access-Token", 
    localStorage.shippingTableApiToken
  );
  myHeaders.append("Content-Type", "application/json");

  let graphql = JSON.stringify({
    query:
      `query{\r\n metaobjects(type: "shipping_rates", first: 100) {\r\n    nodes {\r\n      delivery: field(key: "delivery_method") { value }\r\n      country: field(key: "country") { value }\r\n      cost: field(key: "cost") { value },\r\n      speed: field(key: "delivery_speed") { value }\r\n      order: field(key: "order") { value }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n`,
    variables: {},
  });
  
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch (
    `${localStorage.permanentStoreDomain}/api/2023-01/graphql.json`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
}

async function createShippingTable(parentElement, countryToFilter) {
  const dataSet = await getShippingMetaObject();

  // Parse the data set into a JavaScript object
  const data = JSON.parse(dataSet);

  // Access the nodes array and filter by country
  const filteredNodes = data.data.metaobjects.nodes.filter(
    (node) => node.country.value === countryToFilter
  );

  // Create the HTML table
  const table = document.createElement("table");
  table.id = "shippingTable";

  // Create the table headers
  const headers = ["Service", "Cost", "Delivery"];
  const headerRow = document.createElement("tr");
  headerRow.innerHTML = headers.map((header) => `<th>${header}</th>`).join("");
  table.appendChild(headerRow);

  // Create the table rows
  const rows = filteredNodes
    .map((node) => {
      const costArray = JSON.parse(node.cost.value);
      const costHTML = costArray.map((cost) => `<div>${cost}</div>`).join("");
      return `
      <tr>
        <td>${node.delivery.value}</td>
        <td>${costHTML}</td>
        <td>${node.speed.value}</td>
      </tr>
    `;
    })
    .join("");
  table.innerHTML += rows;

  // Append the table to the parentElement
  document.querySelector(parentElement).appendChild(table);
}


function initSearchPredictive() {
  const searchForms = document.querySelectorAll('.search__predictive__form');

  function handleChangeInSearchInput(searchInput, searchClose) {
    searchClose.classList.toggle('search__predictive__close__inner--active', searchInput.value !== '');
  }

  function handleSearchCloseClick(e, searchInput, searchClose) {
    e.preventDefault();
    searchInput.value = "";
    handleChangeInSearchInput(searchInput, searchClose);
  }

  searchForms.forEach(form => {
    const searchInput = form.querySelector('.search__predictive__form > input[type="search"]');
    const searchClose = form.querySelector('.search__predictive__close__inner');

    searchInput.addEventListener('input', () => handleChangeInSearchInput(searchInput, searchClose));
    searchClose.addEventListener('click', (e) => handleSearchCloseClick(e, searchInput, searchClose));
  })
}

initSearchPredictive();


// keeps heart / favorite button state updated across the current page
document.addEventListener('DOMContentLoaded', () => {
  const heartButtons = document.querySelectorAll('button.heart-button');
  for (let button of heartButtons) {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      setTimeout(() => {
        _swat.initializeActionButtons('body');
      } ,1000)
    })
  }
});


// generic function to add one or more cart attributes; just pass them in as an object
const addCartAtts = (data, callback) => {
  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      attributes: data
    }),
  }).then((res) => {
    return res.json();
  }).then(() => {
    typeof callback === 'function' && callback();
  })
};


// generic function to remove product from cart
const removeFromCart = (id, callback) => {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      quantity: 0,
      id: id.toString()
    }),
  }).then(async (res) => {
    // hide if still visible after cart removal; mainly for the /cart page
    let lineItems = document.querySelectorAll('[data-cart-item]');
    for (let lineItem of lineItems) {
      if (lineItem.dataset.variantId === id.toString()) {
        lineItem.style.display = 'none';
        break;
      }
    }

    return res;
  }).then(() => {
    typeof callback === 'function' && callback();
  })
};


// Removes enrollment products from cart if customer is a logged-in consultant
const removeEnrollmentProducts = async () => {
  if (sessionStorage.isPartner) {
    const opts = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const cart = await fetch('/cart.js', opts).then((res) => res.json());

    for (let item of cart.items) {
      try {
        const req = await fetch(`https://pureromancedtc.myshopify.com/products/${item.handle}.json`)
          .then((res) => {
            return res.json();
          });

        if (req.product.id === undefined) {
          throw new Error('Unable to retrieve product object.');
        }

        const { product } = req;
        const cart_drawer_variant = item.variant_id;

        const tags = product.tags !== undefined ? product.tags : [];
        if (!tags.length > 0) {
          throw new Error('Unable to retrieve product tags.');
        }

        if (tags.includes('Enrollment') || tags.includes('Enrollment'.toLowerCase())) {
          removeFromCart(cart_drawer_variant)
          console.log(`Variant ${cart_drawer_variant} was removed from the cart.`)
        }
      } catch(e) {
        console.warn(e);
      }
    }
  } else {
    return;
  }
}

// Also need to run `removeEnrollmentProducts` any time the cart is updated
document.addEventListener('DOMContentLoaded', removeEnrollmentProducts)